<template>
    <div class="bookmark_management_box">
        <h4>{{$t('mylibrary.bookmarks.foldermanagement')}}</h4>
        <div class="input-group mb-3">
                <input type="hidden" v-model="newfolder.folderId">
                <input type="hidden" v-model="newfolder.flag" >
                <input type="text" class="form-control" v-model="newfolder.folderName" placeholder="폴더명" aria-label="Recipient's username" aria-describedby="button-addon2">
                <button class="btn btn-primary" @click="saveFolder" type="button" id="button-addon2">{{$t('common.save')}}</button>
        </div>
        <div class="b_m_list">
            <h5>{{$t('mylibrary.bookmarks.existFolder')}}</h5>
            <ul>
            <li v-for="(folder,index) in folders" :key="index">
                <span @click="updateFolder(folder)">{{folder.folderName}}</span>
                <a href="#" class="list_del" @click="deleteFolder(folder)">Delete</a>
            </li>
            </ul>
        </div>
        <div class="text-center pt-4">   
            <router-link to="/mylibrary/bookmarks" class="btn btn-primary">{{$t('common.list')}}</router-link>
        </div>
    </div>
</template>

<script>
import { bookmarkList,saveFolder,deleteFolder } from '@/api/bookmark';

export default {
data() {
    return {
		folders: '',
        folderName : '',
        newfolder : {
            folderName : '',
            flag : "I",
            userId : ''
        },
		component: null, 
        confirmYN : false,
        folderId : ''
    };
  },
  mounted(){
    this.fetchData();
  },  
  methods: {
	async fetchData(){  
        try{
            const response = await bookmarkList();		
            this.folders = response.data.folderList; 
        }catch(err){
            console.log(err);
        }
	},
    async saveFolder(){
        try{
            const {data} = await saveFolder(this.newfolder);	
            if(data.message!=null){
                alert(this.$t("alert.plzCheckAllValues"));
            }
            if(data.status){
                this.newfolder.folderName='';
                this.newfolder.flag = 'I';
                this.folders = [];
                this.fetchData();
            }else{
                alert(this.$t("alert.ErrorPlzcontactManager"));
            }
        }catch(err){
            console.log(err);
        }
    },
    async deleteFolder(folder){
        this.confirmYN = confirm(this.$t("alert.delete"));
        if(!this.confirmYN){
            return;
        }else{
            try{
                const {data} = await deleteFolder(folder);		
                if(data.status){
                    this.newfolder.flag = 'I';
                    this.folders = [];
                    this.fetchData();
                }else{
                    alert(this.$t("alert.ErrorPlzcontactManager"));
                }
            }catch(err){
                console.log(err);
            }
        }
    },
    updateFolder(folder){
        this.confirmYN = confirm(this.$t("alert.edit"));
        if(this.confirmYN){
            this.newfolder.flag = 'U';
            this.newfolder.folderId = folder.folderId;
            this.newfolder.folderName = folder.folderName;
            this.newfolder.userId= folder.userId;
        }else{
            return;
        }
    }
  }
}
</script>

<style>

</style>